import { useMemo } from 'react'
import { useCookies } from 'react-cookie'
import { daysToSeconds } from 'utils/timeUtils'

const storageKey = 'tokenCredentials'

const useCroodsAuthStorage = () => {
  const [cookies, setCookie, removeCookie] = useCookies([storageKey])

  const storage = useMemo(
    () => ({
      getItem: key => JSON.stringify(cookies[key]),
      setItem: (key, value) => {
        setCookie(key, value, {
          secure: process.env.NODE_ENV === 'production',
          sameSite: 'Lax',
          maxAge: daysToSeconds(14),
          path: '/',
        })
      },
      removeItem: key => removeCookie(key, { path: '/' }),
    }),
    [cookies, setCookie, removeCookie],
  )

  return {
    storage,
    storageKey,
  }
}

export default useCroodsAuthStorage
